var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6705 6.3295C20.1098 6.76884 20.1098 7.48116 19.6705 7.9205L10.6705 16.9205C10.2312 17.3598 9.51884 17.3598 9.0795 16.9205L5.3295 13.1705C4.89017 12.7312 4.89017 12.0188 5.3295 11.5795C5.76884 11.1402 6.48116 11.1402 6.9205 11.5795L9.875 14.534L18.0795 6.3295C18.5188 5.89017 19.2312 5.89017 19.6705 6.3295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.841b26bd57dca8acbbc8974919f13c81.svg";
export { ForwardRef as ReactComponent };